import { qs, qsAll } from '../common/utils'

export default class Banner {
  constructor() {
    const el = qs('.p-top-banner')
    if(!el) return
    
    const banner = qsAll('.p-top-banner__a')
    
    let clickCount = 0
    
    banner.forEach( target =>
    {
      const close = target.querySelector(".close")
      
      close.addEventListener("click", ()=>{
        target.classList.add("is-hide");
        
        clickCount++
        
        setTimeout(()=>{
          target.classList.add("is-none");
          el.classList.add("is-single");
          
          if(clickCount === banner.length)
          {
            el.classList.add("is-hide");
          }
        }, 300)
      })
      
    })
  }
}
